/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  HarvestByProducerExport,
  HarvestByProducerExportVariables,
} from './types/index.graphql'

export const HARVEST_BY_PRODUCER_EXPORT = gql`
  query HarvestByProducerExport(
    $regionId: Int
    $subregionId: Int
    $companyId: Int
    $cropId: Int!
    $seasonStartRange: DateTime
    $seasonEndRange: DateTime
    $varietyId: Int
  ) {
    harvestByProducerExport(
      regionId: $regionId
      subregionId: $subregionId
      companyId: $companyId
      cropId: $cropId
      seasonStartRange: $seasonStartRange
      seasonEndRange: $seasonEndRange
      varietyId: $varietyId
    ) {
      url
    }
  }
`
